import React from 'react';
import RetryButton from 'components/Practice/shared/RetryButton';

const CompletedRecording = ({ handleReload, embedUrl }) => (
  <div className="EditorElement-recordingComplete">
    <div className="Video-redo ta-r p-8">
      <RetryButton onClick={handleReload} />
    </div>
    <iframe
      title="Recording Embed"
      allowFullScreen
      width="100%"
      height="100%"
      allowTransparency="true"
      style={{ backgroundColor: 'transparent' }}
      frameBorder="0"
      src={embedUrl}
    />
  </div>
);

export default CompletedRecording;
